import configLib from 'utils/vue/lib/config'

const ad = window.addiesaas || {}
const bookingsConfig = ad['raceway-booking'] || {}
const need2speed = ad['need2speed'] || {}
const giftcards = ad['giftcards'] || {}
const clubspeed = ad['clubspeed'] || {}
const products = ad['products'] || {}

export const config = Object.assign(
{},
    bookingsConfig,
  {
      giftcards,
      need2speed,
      products,
      clubspeed,
  },
  configLib)
console.log(ad.connected);
if (!ad.connected) {
  console.error('Unable to connect to Clubspeed API!');
}
export default config

